// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"375":"32eb7b16","455":"1b991356","626":"e398d4f2","629":"3c99ad5f","977":"1fa8c7fd"}[chunkId] + ".chunk.js";
};